module.exports = __webpack_public_path__ + "img/whatsapp.17812732.svg";